module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<td><input type="text" class="form-control transparent-input role-name" value="'+
((__t=( templateName ))==null?'':_.escape(__t))+
'"></td>\r\n<td>\r\n    <select class="form-control transparent-input role-type" style="width:120px;">\r\n        <option></option>\r\n        <option value="document" ';
 if (templateType == 'document') { 
__p+=' selected ';
 } 
__p+=' >Document</option>\r\n        <option value="organization" ';
 if (templateType == 'organization') { 
__p+=' selected ';
 } 
__p+=' >Organization</option>\r\n        <option value="person" ';
 if (templateType == 'person') { 
__p+=' selected ';
 } 
__p+=' >Person</option>\r\n    </select>\r\n</td>\r\n<td><input type="checkbox" class="form-control" value="canRead" ';
 if (canRead) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n<td><input type="checkbox" class="form-control" value="canReadAll" ';
 if (canReadAll) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n<td><input type="checkbox" class="form-control" value="canReadFor" ';
 if (canReadFor) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n<td><input type="checkbox" class="form-control" value="canWrite" ';
 if (canWrite) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n<td><input type="checkbox" class="form-control" value="canWriteFor" ';
 if (canWriteFor) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n<td><input type="checkbox" class="form-control" value="canWriteAll" ';
 if (canWriteAll) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n<td><input type="checkbox" class="form-control" value="canDelete" ';
 if (canDelete) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n<td><input type="checkbox" class="form-control" value="canSign" ';
 if (canSign) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n<td><input type="checkbox" class="form-control" value="canSignAll" ';
 if (canSignAll) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n<td><input type="checkbox" class="form-control" value="canUploadFor" ';
 if (canUploadFor) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n<td><input type="checkbox" class="form-control" value="canChangeReviewer" ';
 if (canChangeReviewer) { 
__p+=' checked ';
 } 
__p+=' ></td>\r\n<td class="hiddenable-compliment"><span class="glyphicon glyphicon-minus clickable role-delete form-control transparent-input" title="Remove role" rel-id="'+
((__t=( id ))==null?'':__t)+
'"/></td>\r\n<td class="hiddenable"><span class="glyphicon glyphicon-ok clickable role-update form-control transparent-input" title="Save changes" rel-id="'+
((__t=( id ))==null?'':__t)+
'"/></td>\r\n<td class="hiddenable"><span class="glyphicon glyphicon-remove clickable cancel form-control transparent-input" title="Discard changes" rel-id="'+
((__t=( id ))==null?'':__t)+
'"/></td>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/roles/roles-row.html
// module id = 449
// module chunks = 0